/* ==========================================================================
   SALVATORE SORRENTINO ｜ 7日間 ご自宅確認サービス
   ss-tryon.js
   - FAQ アコーディオン開閉
   - ページ内スムーススクロール（CTA→サービス見出し）
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ssTryonInit === '1') return;
    root.dataset.ssTryonInit = '1';
    root.classList.remove('no-js');

    // --- FAQ アコーディオン ---
    var faqs = root.querySelectorAll('.ss-faq .fq');
    faqs.forEach(function (fq, i) {
      var q = fq.querySelector('.q');
      var a = fq.querySelector('.a');
      if (!q || !a) return;

      // アクセシビリティ属性
      var id = 'ss-faq-a-' + i + '-' + Math.random().toString(36).slice(2, 7);
      a.setAttribute('id', id);
      q.setAttribute('role', 'button');
      q.setAttribute('tabindex', '0');
      q.setAttribute('aria-expanded', 'false');
      q.setAttribute('aria-controls', id);

      function toggle() {
        var open = fq.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      q.addEventListener('click', toggle);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    // --- CTA スムーススクロール ---
    var ctas = root.querySelectorAll('a[href^="#"]');
    ctas.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var tgt = root.querySelector(href) || document.querySelector(href);
        if (!tgt) return;
        e.preventDefault();
        tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('.ss-tryon').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify テーマエディタで再描画された場合にも対応
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
